<template>
  <div>
    <el-collapse v-model="activeNames" style="border: none;">
      <el-collapse-item title="会员查询" name="1" style="margin: 0px 20px 0 20px;padding: 20px;">
        <el-form :inline="true" label-width="110px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
          <el-form-item label="手机号码">
            <el-input v-model="contact"></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex;flex-flow: row;">
          <el-button type="primary" icon="el-icon-search" style="margin-top: 10px; margin-left: 10px;" @click="querymember">查询会员</el-button>
          <el-button type="success" icon="el-icon-download" style="margin-top: 10px; margin-left: 10px;" @click="exporthyexcel">导出Excel</el-button>
          <el-button type="success" icon="el-icon-download" style="margin-top: 10px; margin-left: 10px;" @click="syncuser">同步公众号会员</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-tabs v-model="activeName" type="card" style="margin: 0 40px 0 40px;">
      <el-tab-pane label="公众号会员信息" name="gzhuser">
        <el-table
          stripe
          :data="gzhuserlist"
          ref="wx_userlist">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="openid"
            label="OpenId"
          >
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="用户昵称"
          >
          </el-table-column>
          <el-table-column
            prop="userimg"
            label="用户头像"
          >
          </el-table-column>
          <el-table-column
            prop="country"
            label="国家"
          >
          </el-table-column>
          <el-table-column
            prop="province"
            label="省"
          >
          </el-table-column>
          <el-table-column
            prop="province"
            label="市"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="查看用户" placement="top-start">
                <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="getuserinfo(scope.$index, userlist)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="小程序会员信息" name="minuser">
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="memberdata"
          ref="multipleTable">
          <el-table-column
            prop="usernick"
            width = "200px"
            label="会员昵称">
          </el-table-column>
          <el-table-column
            label="头像">
            <template slot-scope="scope">
              <div v-if="scope.row.userimg">
                <img :src="scope.row.userimg" class="avatarimg">
              </div>
              <div v-else>
                {{scope.row.userimg}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="电话号码">
          </el-table-column>
          <el-table-column
            width = "200px"
            prop="openid"
            label="OpenID">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="设置会员卡状态" placement="top-start">
                <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="bindcard(scope.$index, memberdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="查看收货地址" placement="top-start">
                <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="seeshdz(scope.$index, memberdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="注销该会员" placement="top-start">
                <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="delmember(scope.$index, memberdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="公众号地址导入(勾选后，可独立下载)" :visible.sync="visgzhaddress">
      <div style="display: flex;flex-flow: row;">
        <el-button type="success" icon="el-icon-download" style="margin-top: 10px;" @click="downuser">开始下载</el-button>
      </div>
      <el-progress :percentage="percentage"></el-progress>
      <div style="font-size: 12px; color: #00a67c;">已选择{{gzhusercount}}个，已下载{{completeusercount}}个</div>
      <el-table
        stripe
        :data="userlist"
        @selection-change="selgzhusers"
        ref="wx_userlist">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="openid"
          label="OpenId"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看用户" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="getuserinfo(scope.$index, userlist)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="cardstate" :visible.sync="visbindcard">
      <el-tabs >
        <el-tab-pane label="手动设定级别（设定后自动级别将失效）" >
          <div>
            <el-form  label-width="150px">
              <el-row class="querypanel" style="margin-top:10px;">
                <el-col :span="12">
                  <el-form   label-width="120px" label-position="left">
                    <el-form-item label="VIP等级选择:" >
                      <el-select v-model="viplevel" filterable placeholder="请选择类别" @change="levelchange">
                        <el-option
                          v-for="item in viplevels"
                          :key="item.level"
                          :label="item.level"
                          :value="item.level"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-button style="margin-top: 20px" @click="addcard">手动设定级别</el-button>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自动开卡设定" >
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="用户当前消费:">
                  {{xfcount}}
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-switch
                v-model="autocard"
                @change="changemodel"
                active-text="已激活"
                active-color="#13ce66"
                inactive-text="未激活"
                inactive-color="#ff4949">
              </el-switch>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="自动会员级别:">
                  {{automlevel}}
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="升级需要:">
                  {{nextprice}}
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title="收货地址管理" :visible.sync="visshdz">
      <el-table
        stripe
        :data="shdzdata"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="ID">
        </el-table-column>
        <el-table-column
          prop="username.String"
          width = "200px"
          label="收货人">
        </el-table-column>
        <el-table-column
          prop="contact.String"
          width = "200px"
          label="联系方式">
        </el-table-column>
        <el-table-column
          prop="shengid.String"
          label="省">
        </el-table-column>
        <el-table-column
          prop="shiid.String"
          label="市">
        </el-table-column>
        <el-table-column
          prop="dq.String"
          label="区">
        </el-table-column>
        <el-table-column
          prop="ssaddress.String"
          label="具体地址">
        </el-table-column>
        <el-table-column
          width = "200px"
          prop="zipcode.String"
          label="邮编">
        </el-table-column>
        <el-table-column
          width = "200px"
          prop="areacode.String"
          label="区域码">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="注销地址" placement="top-start">
              <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="delshdz(scope.$index, shdzdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import XLSX from 'xlsx'
Vue.prototype.$http = axios
var that
export default {
  name: 'PageInfo',
  data () {
    return {
      memberdata: [],
      bymemberdate: '',
      percentage: 0,
      gzhusercount: 0,
      completeusercount: 0,
      activeNames: ['1'],
      activeName: 'orderview',
      visbindcard: false,
      visshdz: false,
      contact: '',
      selectuserid: 0,
      xfcount: 0,
      autocard: true,
      visgzhaddress: false,
      automlevel: -1,
      nextprice: 0,
      viplevels: [],
      shdzdata: [],
      viplevel: '',
      cardstate: '会员卡设置',
      cardinfos: [],
      userlist: [],
      gzhuserlist: [],
      cardinfo: 1,
      accesstoken: '',
      selgzhuserdata: ''
    }
  },
  async mounted () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    this.accesstoken = await getaccesstoken()
    // that.getuserlist()
    that.getgzhuserlist()
    console.log('获取卡面信息')
    var qstr = 'cusid = ' + this.khid
    that.$http({
      url: 'https://api.sqnetsoft.cn/cardticket/getbcm',
      method: 'post',
      data: {
        whereinfo: {String: qstr, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          console.log(JSON.parse(res.data.data))
          that.cardinfos = JSON.parse(res.data.data)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
    var qstr1 = 'cusid = ' + this.khid
    that.$http({
      url: 'https://api.sqnetsoft.cn/cardticket/getbcl',
      method: 'post',
      data: {
        whereinfo: {String: qstr1, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          console.log(JSON.parse(res.data.data))
          that.viplevels = JSON.parse(res.data.data)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  methods: {
    selgzhusers (val) {
      that.selgzhuserdata = val
      window.console.log(that.selgzhuserdata)
      that.gzhusercount = that.selgzhuserdata.length
    },
    downuser () {
      for (var i = 0; i < that.selgzhuserdata.length; i++) {
        that.getuserinfo(that.selgzhuserdata[i].openid)
      }
    },
    drawLine (tmpdata) {
      var xdata = []
      var ydata = []
      for (var i = 0; i < tmpdata.length; i++) {
        xdata.push(tmpdata[i].op_time)
        ydata.push(tmpdata[i].count_price)
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById('mymainChart'))
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['会员数']
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xdata
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: ydata,
          type: 'line'
        }]
      })
      window.onresize = myChart.resize
    },
    syncuser () {
      var that = this
      that.visgzhaddress = true
      that.getuserlist()
    },
    getgzhuserlist () {
      var qstr = {
        whereinfo: '',
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywxgzhuser',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length >0) {
            that.gzhuserlist = res.data
          } else {
            that.gzhuserlist = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    async getuserinfo (openid) {
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getuserbyopenid',
        method: 'post',
        data: {
          accesstoken: this.accesstoken,
          openid: openid
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            window.console.log(tmpdata)
            that.nickname = tmpdata.nickname
            that.imgurl = tmpdata.headimgurl
            that.city = tmpdata.city
            that.country = tmpdata.country
            that.province = tmpdata.province
            window.console.log(that.imgurl)
            // 把相关数据缓存到本地
            var adata = {
              openid: openid,
              nickname: tmpdata.nickname,
              userphone: '',
              country: tmpdata.country,
              province: tmpdata.province,
              city: tmpdata.city,
              userimg: tmpdata.headimgurl
            }
            that.$http({
              url: 'https://ecommapi.sqnetsoft.cn/addwxgzhuser',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.result === 'success') {
                  that.completeusercount = that.completeusercount + 1
                } else {
                }
              })
              .catch(function (error) {
                window.console.log(error)
              })
          } else {
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    async getuserlist () {
      var adata = {
        accesstoken: this.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getuseropenids',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            window.console.log(tmpdata)
            that.userlist = []
            for (var i = 0; i < tmpdata.data.openid.length; i++) {
              var data = {
                openid: tmpdata.data.openid[i]
              }
              that.userlist.push(data)
            }
            // 把相关数据缓存到本地
          } else {
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    exporthyexcel () {
      var xlsdata = []
      for (var i = 0; i< that.memberdata.length; i++) {
        var tmpdata = that.memberdata[i]
        var xlstmp = {
          'ID': tmpdata.id,
          '姓名': tmpdata.name.String,
          '昵称':tmpdata.nickname.String,
          '联系方式': tmpdata.phone.String,
          '职务': tmpdata.post.String,
          'OPENID': tmpdata.wxopenid.String,
          '注册时间': tmpdata.optime.String
        }
        xlsdata.push(xlstmp)
      }
      // 表名
      var ws = XLSX.utils.json_to_sheet(xlsdata);
      /* get binary string as output */
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '会员信息');
      /* 生成xlsx文件 */
      XLSX.writeFile(wb, '会员信息.xlsx');
    },
    loadAreaList (curuserid) {
      var qstr = 'userid = ' + curuserid
      window.console.log(qstr)
      // var qstr = 'id = ' + localStorage.getItem('curgoodsid')
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbua',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              var tmpdata = JSON.parse(res.data.data)
              window.console.log('获取收货地址')
              window.console.log(tmpdata)
              that.shdzdata = tmpdata
            }
            // 把相关数据缓存到本地
          } else {
            window.console.log('获取商品失败')
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    changemodel (value) {
      console.log(value)
      // 变更该用户的状态
      var state = -1
      if (value) {
        state = 1
      } else {
        state = 0
      }
      var updata = {
        userid: parseInt(this.selectuserid),
        ifautocard: parseInt(state),
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/cardticket/aaubmac',
        method: 'post',
        data: updata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (value) {
              that.cardstate = '会员卡设置: 当前为自动模式'
            } else {
              that.cardstate = '会员卡设置: 当前为手动模式'
            }
            that.$message({
              type: 'success',
              message: '状态已变更!'
            })
          }
        })
    },
    querymemberlevel (userid) {
      var qstr = "userid ='" + userid + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/cardticket/getbmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success && res.data.data !== '[]') {
            var data = JSON.parse(res.data.data)
            that.viplevel = data[0].levelid
          } else {
            that.viplevel = 1
          }
        })
    },
    querymemberstate (userid) {
      var qstr = "userid ='" + userid + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/cardticket/getbmac',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success && res.data.data !== '[]') {
            var data = JSON.parse(res.data.data)
            if (data[0].ifautocard === 1) {
              that.autocard = true
              that.cardstate = '会员卡设置: 当前为自动模式'
            } else {
              that.autocard = false
              that.cardstate = '会员卡设置: 当前为手动模式'
            }
          } else {
            that.autocard = false
            that.cardstate = '会员卡设置: 当前为手动模式'
          }
        })
    },
    querymember () {
      that.activeName = 'minuser'
      var qstr = ' LENGTH(openid) = 28'
      if (this.contact !== null && this.contact !== '' && this.contact !== '0') {
        qstr = qstr + " and phone like '%" + this.phone + "%'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywxuser',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res.data)
          if (res.data.length > 0) {
            that.memberdata = res.data
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delmember (index, data) {
      console.log(data[index])
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id === selectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      var qstr = 'id = ' + selectdata.id
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/delcususer',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    bindcard (index, data) {
      that.visbindcard = true
      console.log(data[index])
      this.selectuserid = data[index].id
      that.$options.methods.querymemberstate(data[index].id)
      that.$options.methods.querymemberlevel(data[index].id)
      console.log('获取用户消费金额')
      var qstr = 'buy_cus_id  = ' + that.selectuserid + ' and sale_cus_id= ' + that.khid + ' and state_id > 1'
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/goc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.xfcount = JSON.parse(res.data.data)
            console.log('根据用户消费金额设定用户等级')
            var qstr1 = 'cusid  = ' + that.khid
            that.$http({
              url: 'https://api.sqnetsoft.cn/cardticket/getbcl',
              method: 'post',
              data: {
                whereinfo: {String: qstr1, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  var tmpdatas = JSON.parse(res.data.data)
                  console.log('根据用户消费金额设定用户等级')
                  for (var i = 0; i < tmpdatas.length; i++) {
                    if (that.xfcount <= tmpdatas[i].count) {
                      if (i === 0) {
                        that.automlevel = 0
                      } else {
                        that.automlevel = i
                      }
                      that.nextprice = tmpdatas[i].count
                      return
                    }
                  }
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeshdz (index, data) {
      this.selectuserid = data[index].id
      that.$options.methods.loadAreaList(this.selectuserid)
      this.visshdz = true
    },
    delshdz (index,data) {
      console.log(data[index])
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id === selectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      var qstr = 'id = ' + selectdata.id
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/delbua',
        method: 'post',
        data: {
            whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    levelchange () {},
    cardchange () {},
    addcard () {
      var whereinfo = ' userid = ' + that.selectuserid
      var fieldparams = ' levelid=' + that.viplevel
      that.$http({
        url: 'https://api.sqnetsoft.cn/cardticket/upbmc',
        method: 'post',
        data: {
          fieldparams: {String: fieldparams, Valid: true},
          whereinfo: {String: whereinfo, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已设置该用户等级为' + that.viplevel
            })
            var updata = {
              userid: parseInt(that.selectuserid),
              ifautocard: parseInt(0),
              cusid: parseInt(that.khid)
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/cardticket/aaubmac',
              method: 'post',
              data: updata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.cardstate = '会员卡设置: 当前为手动模式'
                  that.autocard = false
                  that.$message({
                    type: 'success',
                    message: '状态已变更!'
                  })
                }
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
async function getaccesstoken () {
  return new Promise(resolve => {
    that.$http({
      url: 'https://wx.sqnetsoft.cn/wx/getaccesstoken',
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        window.console.log(res)
        if (res.status === 200) {
          window.console.log(res.data)
          resolve(res.data)
        } else {
          window.console.log('返回错误')
          resolve('')
        }
      })
      .catch(function (error) {
        window.console.log(error)
        resolve('')
      })
  })
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
/* function RondomPass (number) {
  var arr = []
  var arr1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

  for (var i = 0; i < number; i++) {
    var n = Math.floor(Math.random() * 10)
    arr[i] = arr1[n]
  }
  var valinfo = arr.join('')
  return valinfo
} */
</script>



// WEBPACK FOOTER //
// src/components/member/MemberInfo.vue